import Component from './NotFoundPage';

export default Component;